const initialState = {
  menu: '',
  submenu: '',
  box:''
};

export default initialState;


// WEBPACK FOOTER //
// ./source/client/reducers/nav/initialState.js